import { register } from 'register-service-worker';

console.log("MODE: " + process.env.NODE_ENV);


if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n'
            );
        },
        registered(registration) {
            console.log('Service worker has been registered.');
            setInterval(() => {
                registration.update();
            }, 10000); // e.g. hourly checks
        },
        cached() {
            console.log('Content has been cached for offline use.');
        },
        updatefound() {
            console.log('New content is downloading.');
        },
        updated(registration) {
            console.log('New content is available; Refresh...');
            document.dispatchEvent(
                new CustomEvent('swUpdated', { detail: registration })
            );
        },
        offline(registration) {
            console.log('No internet connection found. App is running in offline mode.');
            document.dispatchEvent(
                new CustomEvent('swOffline', { detail: "OfflineMode" })
            );
        },
        error(error) {
            console.error('Error during service worker registration:', error);
        },
    });
}
